import React from 'react'
import Link from 'next/link'
import LayoutBasic from '../layouts/layoutBasic'
import { Tabs, Tab } from 'react-bootstrap-tabs';
import { LOGIN_URL, TOKEN, SET_COOKIE, LOGIN_UPLOAD_URL, UPLOAD_LOGIN_URL, UPLOAD_PICXY_URL_REDIRECT } from '../vars'
import { setLocalKeyValue, getLocalKeyValue, getSessionKeyValue } from '../storage'
import { withRouter } from 'next/router'
import { GET, POST, UPOST } from '../helpers'
import SOCIAL_GOOGLE_LOGIN from '../components/googleSignup'
import { Formik, Field, Form, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import { SeoMetaBasic } from '../components/seoMeta'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

class Login extends React.Component {

  constructor() {
    super()
    this.state = {
      gle_login_success: false, gle_login_processing: false,
      loginSuccess: false, loginError: false, password: '', submitting: false, username: '', pswdHidden: true
    }
  }

  showHidePassword = (e) => {
    this.setState({ pswdHidden: !this.state.pswdHidden });
  }

  inputChange = (e) => {
    let name = e.target.name
    let value = e.target.value
    this.setState({
      [name]: value,
    });
    if (name == "email") {
      this.setState({ email_error: '' })
    }
    else if (name == "password") {
      this.setState({ password_error: '' })
    }
    // else if (name == "username") {
    //   this.setState({username_error:''})
    // }
    // else if (name == "upload_password") {
    //   this.setState({upload_password_error:''})
    // }
    this.setState({ submit_failed: false, submit_success: false, submitting: false, msg: '' })
  }
  login = (e) => {
    e.preventDefault();
    let error_free = true

    if (this.state.email) {
      let re = /\S+@\S+\.\S+/;
      if (!re.test(this.state.email)) {
        error_free = false
        this.setState({ email_error: 'Invalid Email id' })
      }
      else {
        this.setState({ email_error: '' })
      }
    }
    else {
      error_free = false
      this.setState({ email_error: 'Email is required' })
    }
    if (!this.state.password) {
      error_free = false
      this.setState({ password_error: 'Password is required' })
    }
    if (error_free) {
      this.setState({ submitting: true })
      let data = {
        username: this.state.email,
        password: this.state.password
      }
      this.setState({ msg: "" })
      UPOST(LOGIN_URL, data).then((response) => {
        if (response.data.token) {
          setLocalKeyValue(TOKEN, response.data.token)
          document.cookie = "token=" + response.data.token + ";path=/;"

          this.setState({ submit_success: true, submitting: false })

          if (getSessionKeyValue('referer')) {
            let ref = getSessionKeyValue('referer')
            sessionStorage.removeItem('referer')
            window.location.href = ref
          }
          else {
            window.location.href = "/ai_face_sync"
          }
        }
      }).catch((error) => {
        let res = error.response.data
        if (res.server_error) {
          if (res.server_error == "No User matches the given query.") {
            this.setState({ submitting: false, submit_failed: true, msg: <span>Unable to log in with provided credentials.</span> })
          }
          else {
            this.setState({ submitting: false, submit_failed: true, msg: "Something went wrong, please try again" })
          }
        }
        else {
          this.setState({ submitting: false, submit_failed: true, msg: res.error })
        }
      })
    }
  }

  render() {

    let submitButton = <button type="submit" className="btn btn-primary w-100">Login </button>

    if (this.state.submit_success) {
      submitButton = <button type="submit" className="btn btn-success w-100">Login Success</button>
    }
    if (this.state.submit_failed) {
      submitButton = <button type="submit" className="btn btn-danger w-100" disabled>Login Failed</button>
    }
    if (this.state.submitting) {
      submitButton = <button type="submit" className="btn btn-primary w-100" disabled>Loading...</button>
    }

    let form = <div>
      <form onSubmit={this.login} className="mb-3">

        <div className="mb-3">
          <label className='form-label' htmlFor="email">Email</label>
          <input name="email" type="text" className='form-control' onChange={this.inputChange} value={this.state.email} />
          <div className="d-block invalid-feedback">{this.state.email_error}</div>
        </div>
        <div className="mb-3">
          <label className='form-label' htmlFor="password">Password</label>
          <span className="pull-right text-picxy pointer" onClick={this.showHidePassword}>
            <FontAwesomeIcon icon={this.state.pswdHidden ? faEyeSlash : faEye} className="" /> {this.state.pswdHidden ? "Show" : "Hide"}</span>
          <input name="password" type={this.state.pswdHidden ? 'password' : 'text'} className='form-control' onChange={this.inputChange} value={this.state.password} />
          <div className="d-block invalid-feedback">{this.state.password_error}</div>
        </div>
        <h6>
          {this.state.msg ? <div className="">{this.state.msg}</div> : ""}
        </h6>
        <div className="mb-3">
          {submitButton}

        </div>
      </form>
      <div className="mb-1">
        Don't have an account? <Link href="/signup-customer"><a><u>Sign up</u></a></Link>
      </div>
      <div>
        <Link href="/password_reset">
          <a>Forgot password?</a>
        </Link>
      </div>
    </div>

    let login_customer = <div className="container">
      <div className="row justify-content-center">
        <div className="col-md-5 login my-4">
          <div className="card card-hidden-xs mt-4 mt-sm-0 mb-4">
            <div className="card-body p-0 p-sm-4">
              <h6 className="space-mb-medium text-center mb-1">
                Login as customer
              </h6>
              <p className="f-18 text-center mb-4">Welcome back to Picxy</p>
              <SOCIAL_GOOGLE_LOGIN />
              {form}
            </div>
          </div>
        </div>
      </div>
    </div>

    return <LayoutBasic title="Picxy Customer Login" {...this.props}>
      <SeoMetaBasic name="Picxy Customer Login" description="Welcome back to picxy" {...this.props} />
      {login_customer}

    </LayoutBasic>
  }

}

export default withRouter(Login)
